import { QueryClient } from '@tanstack/react-query';
import { useAuthStore } from '@/stores/authStore';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

// Every way out of a session ends in the store's logout: the shell's logout button, useAuth().logout, and a
// failed token refresh in api.ts. Clearing here means the next staff member never sees the previous one's data.
useAuthStore.subscribe((state, previous) => {
  if (previous.isAuthenticated && !state.isAuthenticated) {
    void queryClient.cancelQueries();
    queryClient.clear();
  }
});
